import { render } from "./FlatsFloors.vue?vue&type=template&id=3624d546"
import script from "./FlatsFloors.vue?vue&type=script&lang=js"
export * from "./FlatsFloors.vue?vue&type=script&lang=js"

import "./FlatsFloors.vue?vue&type=style&index=0&id=3624d546&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__